import React, { Fragment, useEffect, useState, useContext } from "react";
import { PermissionContext, RolePermissions } from "appContext";
import { getAPI, masterServiceBaseUrl } from "services/http";
import { PermisionDenied } from "../../common/commonComponents";
import { endpoint, pages } from "../../common/constant";
import PincodeTable from "./pincodeTable";
import {
  failureToast,
  successToast,
} from "../../common/utils/methods/toasterFunctions/function";
import {
  fetchAllPostPromisedData,
  fetchAllPromisedData,
} from "../../common/utils/methods/commonMethods/utilityMethod";
import { TablePagination } from "@mui/material";
import ALoader from "../../common/a-loader";

import { isObjEmpty } from "./constants";

const Pincode = () => {
  const [classArray, setclassArray] = useState([]);
  const [apiloader, setapiloader] = useState(false);

  const [district, setDistrict] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [city, setCity] = useState([]);

  const [isSaveVisible, setisSaveVisible] = useState(false);
  const [pagination, setpagination] = useState({});

  const permissions = useContext(PermissionContext);
  const userPermissions = RolePermissions(permissions, pages["Pincode"]["id"]);

  const fetchDropdown = async (url, droptype) => {
    setapiloader(true);
    getAPI(
      url,
      (data) => {
        const dropList = data.data.map((data) => {
          if (droptype === "country") {
            const { id, countryDispValue, status } = data;
            return { value: id, label: countryDispValue };
          }

          if (droptype === "state") {
            const { id, stateDispValue, status } = data;
            return { value: id, label: stateDispValue };
          }

          if (droptype === "district") {
            const { id, districtDispValue, status } = data;
            return { value: id, label: districtDispValue };
          }

          if (droptype === "city") {
            const { id, cityDispValue, status } = data;
            return { value: id, label: cityDispValue };
          }
        });

        droptype === "country"
          ? setCountries(dropList)
          : droptype === "state"
          ? setStates(dropList)
          : droptype === "district"
          ? setDistrict(dropList)
          : setCity(dropList);
      },
      (data) => {
        failureToast(data["message"]);
      }
    );
  };

  const fetchAllPincodeData = async (pageNumber = 0) => {
    try {
      setapiloader(true);
      const resp = await fetchAllPromisedData(
        `${endpoint?.pincode?.getAllPinCodePaginated}/${pageNumber}`,
        true
      );

      if (resp?.code === 200) {
        const { pincodeMasterDTOList, currentPage, totalPage, totalRecords } =
          resp?.data;
        setclassArray(pincodeMasterDTOList);
        setpagination({
          currentPage,
          totalRecords,
          totalPage,
          forSearch: false,
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setapiloader(false);
    }
  };

  const searchPincodeHandler = async (searchCriteria, page = 0) => {
    try {
      setapiloader(true);
      const resp = await fetchAllPostPromisedData(
        `${endpoint.pincode.searchPinCode}?offset=${page}`,
        searchCriteria
      );
      if (resp?.code === 200) {
        const { pincodeMasterDTOList, currentPage, totalPage, totalRecords } =
          resp?.data;
        setclassArray(pincodeMasterDTOList);
        setpagination({
          currentPage,
          totalRecords,
          totalPage,
          searchCriteria,
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setapiloader(false);
    }
  };

  const handlePageChange = (filters, page = 0) => {
    !isObjEmpty(filters)
      ? searchPincodeHandler(filters, page)
      : fetchAllPincodeData(page);
  };

  useEffect(() => {
    fetchAllPincodeData();
    fetchDropdown(
      masterServiceBaseUrl + "/district/getAllActiveDistrict",
      "district"
    );
    fetchDropdown(
      masterServiceBaseUrl + "/country/getAllActiveCountry",
      "country"
    );
    fetchDropdown(masterServiceBaseUrl + "/state/getAllActiveState", "state");
    fetchDropdown(masterServiceBaseUrl + "/city/getAllActiveCity", "city");
  }, []);

  const refreshList = () => {
    fetchAllPincodeData();
  };

  return (
    <>
      {apiloader && <ALoader position="fixed" />}
      <Fragment>
        {userPermissions ? (
          <>
            <PincodeTable
              userPermissions={userPermissions}
              fetchAllPincodeData={fetchAllPincodeData}
              setclassArray={setclassArray}
              classArray={classArray}
              countryList={countries}
              stateList={states}
              districtList={district}
              cityList={city}
              pagination={pagination}
              setpagination={setpagination}
              isSaveVisible={isSaveVisible}
              setisSaveVisible={setisSaveVisible}
              refreshList={refreshList}
              apiloader={apiloader}
              searchPincodeHandler={searchPincodeHandler}
              onPageChange={handlePageChange}
            />

            {/* <div className="d-flex justify-content-end mr-2">
              <TablePagination
                component="div"
                count={pagination?.totalRecords}
                page={pagination?.currentPage}
                onPageChange={handlePageChange}
                rowsPerPage={50}
                sx={{
                  "& .MuiInputBase-root": {
                    display: "none",
                  },
                  "& .MuiTablePagination-selectLabel": {
                    display: "none",
                  },
                }}
              />
            </div> */}
          </>
        ) : (
          <PermisionDenied />
        )}
      </Fragment>
    </>
  );
};

export default Pincode;
